import { h, Component } from 'preact';
import { questions, globalLogic, results } from "../questions";

import Question from "./question";
import Start from "./start";
import End from "./end";

export default class extends Component {

	constructor() {
		super();
		this.debug = false;
		// Initialise state for the component
		this.state = {
			currentQuestion: questions[0],
			currentView: 'home',
			answers: [],
			scores: {},
			modifiers: []
		};

		this.handleStateChange('home');
	}

	handleStateChange = (currentView, currentQuestion = {}) => {
		let currentPage = `/${currentView}`;

		if (currentView === 'questions') {
			currentPage = `${currentPage}/${currentQuestion.id}`
		}

		if (currentView === 'end') {
			currentPage = `${currentPage}/${this.getResult().name}`
		}

		const gtmMessage = {
			event: 'cdc_state_change',
			current_page: currentPage
		};

		this.debug && console.log(gtmMessage);

		window.parent.postMessage(gtmMessage, '*');
	}

	getNextQuestion = (currentIndex) => {
		const nextIndex = currentIndex + 1;
		const nextQuestion = questions[nextIndex];

		// Check if next index exists
		if (!nextQuestion) {
			return false;
		}

		if (nextQuestion.conditions && !this.conditionCheck(nextQuestion.conditions)) {
			this.debug && console.log(`Skipping question '${nextQuestion.id}', conditions were not met`);
			return this.getNextQuestion(nextIndex);
		}

		return nextQuestion;
	};

	recordAnswer = (question, answer) => {
		this.setState(prev => {
			const answers = prev.answers;
			answers.push({
				questionId: question.id,
				answerId: answer.id || answer.label,
				answerLabel: answer.label
			});
			this.debug && console.log(answers);
			return {
				answers
			}
		})
	}

	conditionCheck = (conditions) => {
		this.debug && console.log(this.state.modifiers);
		return conditions.every((condition) => {
			if (condition.type === 'modifier') {
				const matches = Array.isArray(condition.match) ? condition.match : [condition.match];
				return matches.some(match => this.state.modifiers.includes(match));
			} else if (condition.type === 'response') {
				const criteria = condition.criteria || '===';
				const answer = this.state.answers.find(ans => ans.questionId === condition.questionId);

				// If the question was not matched, the condition may be being checked by the global logic.
				// Return true to safely skip this conditional check.
				if (!answer) {
					return false;
				}

				if (criteria === '!==' && answer.answerId !== condition.value) {
					return true;
				} else if (criteria === '===' && answer.answerId === condition.value) {
					return true;
				}
			}
			return false;
		});
	};

	recordScores = (answer) => {
		this.setState(prev => {
			const scores = prev.scores;
			Object.keys(answer.scores).forEach( (key) => {
				// If have a condition check, and the condition isn't met, then skip this score addition.
				if (answer.scoreConditions && answer.scoreConditions[key] && !this.conditionCheck(answer.scoreConditions[key])) {
					this.debug && console.log('Skipping recording score, conditions were not met.');
					return;
				}
				scores[key] = (scores[key] || 0) + answer.scores[key];
			});

			this.debug && console.log(scores);

			return {
				scores
			};
		});
	}

	recordModifiers = (answer) => {
		this.setState((prev) => {
			return {
				modifiers: prev.modifiers.concat(answer.modifiers || [])
			};
		})
	}

	handleGlobalLogic = () => {
		for (let index in globalLogic) {
			const logic = globalLogic[index];

			// If the conditions aren't met, skip to the next logic item.
			if (logic.conditions && !this.conditionCheck(logic.conditions)) {
				continue;
			}

			// Update scores
			if (logic.scores) {
				this.recordScores(logic);
			}


			// Handle optional skip to end
			if (logic.skipToEnd) {
				this.changePage('end');
				return false;
			}

		}

		return true;
	}

	handleResponse = (question, answer) => {
		this.recordModifiers(answer);
		this.recordScores(answer);
		this.recordAnswer(question, answer);

		// If false is returned, it means do not continue and skip to end.
		if (!this.handleGlobalLogic()) {
			return;
		}

		const currentQuestionIndex = questions.findIndex(item => item.id === question.id );
		const nextQuestion = this.getNextQuestion(currentQuestionIndex);
		this.setState(() => {
			if (nextQuestion) {
				this.handleStateChange(this.state.currentView, nextQuestion);
				return {
					currentQuestion: nextQuestion
				};
			}

			this.handleStateChange('end');
			return {
				currentView: 'end'
			};
		});

	}

	changePage = (newPage) => {
		this.setState(() => (
			{ currentView: newPage }
		));

		this.handleStateChange(newPage, this.state.currentQuestion);
	}

	start = () => {
		this.changePage('questions');
	}

	restart = () => {
		this.changePage('home');
		// Reset the state.
		this.setState(() => {
			return {
				answers: [],
				scores: {},
				modifiers: [],
				currentQuestion: questions[0]
			};
		});
	}

	getResult = () => {
		const winningKey = Object.keys(this.state.scores).reduce((a, b) => this.state.scores[a] > this.state.scores[b] ? a : b);
		return results.find(result => String(result.id) === String(winningKey));
	}

	questionNumber = () => {
		return this.state.answers.length + 1;
	}

	render() {
		return 	(
			<div>
				{this.state.currentView === 'home' && <Start start={this.start} />}
				{this.state.currentView === 'questions' && <Question questionNumber={this.questionNumber} restart={this.restart} question={this.state.currentQuestion} handler={this.handleResponse} />}
				{this.state.currentView === 'end' && <End restart={this.restart} modifiers={this.state.modifiers} result={this.getResult()}  /> }
			</div>
		);
	}
}
